module.exports = __webpack_public_path__ + "static/24-2f540173eb18a7b6b4baf99b0245b1d7.png";